import {first} from 'lodash';
import {changeOperator, removeCondition, removeSubCondition} from '../actions/query';
import {invalidFieldFound} from '../actions/requiredUserActions';
import {migrateFieldOperatorsConfig} from '../../helpers/migrateFieldOperatorsConfig';

export function validateQuery(categories, query) {
    for (let conditionIndex = 0; conditionIndex < query.AND.length; ++conditionIndex) {
        const condition = query.AND[conditionIndex],
            category = categories.find(cat => cat.id == condition.category);

        // Check for missing/invalid category
        if (!category) {
            return removeCondition(conditionIndex);
        }
    }

    for (let conditionIndex = 0; conditionIndex < query.AND.length; ++conditionIndex) {
        const condition = query.AND[conditionIndex],
            category = categories.find(cat => cat.id == condition.category);

        for (let subConditionIndex = 0; subConditionIndex < condition.OR.length; ++subConditionIndex) {
            const subCondition = condition.OR[subConditionIndex];

            // Check for missing field
            if (!subCondition.field) {
                return removeSubCondition(conditionIndex, subConditionIndex);
            }
            // Check for invalid field
            else if (!category.fields.find(field => field.name == subCondition.field)) {
                return [invalidFieldFound(conditionIndex, category.id, subCondition), removeSubCondition(conditionIndex, subConditionIndex)];
            }

            let field = category.fields.find(field => field.name == subCondition.field);

            // Check for missing/invalid operator
            let operators = migrateFieldOperatorsConfig(field.operators);
            if (!subCondition.operator || !operators.find(op => op.id == subCondition.operator)) {
                let defaultOperator = first(operators);
                if (defaultOperator) {
                    return changeOperator(conditionIndex, subConditionIndex, defaultOperator.id);
                } else {
                    return removeSubCondition(conditionIndex, subConditionIndex);
                }
            }
        }
    }
}
